import { ENV } from './consts';

const getEnv = () => {
  const env_name = $('input#env').val();
  return ENV[env_name.toUpperCase()] || ENV.PRD;
};

const getBidhubBaseUrl = () => {
  const baseUrl = $('input#bidhub_base_url').val();
  return baseUrl || '';
};

const getAppInsightsConfig = () => {
  return {
    connectionString: $('input#applicationinsights_connection_string').val(),
  };
};

export const envName = getEnv();
export const bidhubBaseUrl = getBidhubBaseUrl();
export const appInsightsConfig = getAppInsightsConfig();
